import styled, { css } from "styled-components"

export default function OrderInfoTable({ title, marginBottom, children }) {
  return (
    <Block marginBottom={marginBottom}>
      <Title>{title}</Title>
      {children}
    </Block>
  )
}

const Block = styled.div`
  ${(props) => 
    props.marginBottom && css `
      margin-bottom: ${props.marginBottom};
    `}
`;

const Title = styled.h3`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  line-height: calc(100vw * (16 / 375));
  margin-bottom: calc(100vw * (13 / 375));
`;